import {getCellValue} from "../../../../utils/utils";
import Icon from "../../general/icon";
import {general} from "../../../../store/action";
import {connect, useSelector} from "react-redux";
import React from "react";
import Tooltip from "../../general/tooltip";
import {usePrescriptionInsurerSave} from "../../../../hook/request/visit/prescription";
import {useFindAccessInAccessList} from "../../../../constants/constant/accessProcess";
import OrderedPrescriptionInfoModal
    from "../../ihioPrescriptionBill/orderedPrescriptionInfoModal/orderedPrescriptionInfoModal";

type PrescriptionHistoryTableRowItemProps = {
    item: any;
    handleShowModal: any;
}

const PrescriptionHistoryTableRowItem = ({
    item,
    handleShowModal
}: PrescriptionHistoryTableRowItemProps) => {

    const isProvider = useSelector((state: any) => state.general.userDataReducer.isProvider);
    const {findAccessInAccessList} = useFindAccessInAccessList();
    const prescriptionInsurerSaveRequest = usePrescriptionInsurerSave()


    return (
        <tr>
            <td>{getCellValue(item?.firstName)} {getCellValue(item?.lastName)}</td>
            <td>{getCellValue(item?.nationalCode)}</td>
            <td>{getCellValue(item?.creationDate)}</td>
            <td>{getCellValue(item?.status?.name)}</td>
            <td>{getCellValue(item?.trackingCode)}</td>
            <td>
                <div className="d-flex justify-content-center align-items-center">
                    <Tooltip alt={"مشاهده"} className="tooltip-pre-line">
                        <span

                            onClick={() =>
                                item?.status?.name !== 'نوبت گیری' && handleShowModal('orderedPrescriptionInfo', {nationalCode: item?.nationalNumber, samadCode: item?.samadCode})
                            }
                            className={`d-flex mx-2 font-20 cur-pointer ${item?.status?.name !== 'نوبت گیری' ? 'text-hover' : 'text-gray3'}`}
                        >
                          <Icon name='eye'/>
                        </span>
                    </Tooltip>
                </div>
            </td>
        </tr>
    )
}

const mapDispatchToProps = (dispatch: any) => ({
    handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(PrescriptionHistoryTableRowItem);
